<template>
  <v-dialog
    v-if="loaded"
    v-model="showDialog"
    persistent
    max-width="940px"
    content-class="print-or-save-invoices-dialog"
  >
    <v-card class="print-or-save-dialog-container">
      <component v-if="hasValidatorErrors" :is="checkList" :model="model"/>
      <component v-else :is="steps[model.step]" :model="model"/>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { onMounted, reactive, watchEffect, onUnmounted, ref, onBeforeMount } from 'vue'
import PreviewDocumentComponent from './components/PreviewDocumentComponent.vue'
import DocumentTemplateSelectorComponent from './components/DocumentTemplateSelectorComponent.vue'
import SendingComponent from '@/components/billing/FacturaEDialog/components/SendingComponent.vue'
import {
  facturaEDialogModel,
  IFacturaEDialogModel
} from '@/components/billing/FacturaEDialog/types/FacturaEDialogTypes'
import CheckListComponent from '@/components/billing/FacturaEDialog/components/CheckListComponent.vue'
import useActionsFacturaEDialog from '@/components/billing/FacturaEDialog/composables/useActionsFacturaEDialog'

const props = defineProps({
  showDialog: {
    type: Boolean,
    required: true
  },
  invoiceId: {
    type: Number,
    required: true
  },
  invoiceDescription: {
    type: String,
    required: true
  },
  invoiceTemplates: {
    type: Boolean,
    required: true
  },
})
const model: IFacturaEDialogModel = reactive({
  ...facturaEDialogModel,
  invoiceId: props.invoiceId,
  invoiceDescription: props.invoiceDescription
})
const loaded = ref<boolean>(false)
const {
  hasValidatorErrors,
  validate
} = useActionsFacturaEDialog(model)
const emit = defineEmits(['closeDialog'])
const checkList = CheckListComponent
const steps = props.invoiceTemplates
  ? [DocumentTemplateSelectorComponent, PreviewDocumentComponent, SendingComponent]
  : [SendingComponent]

watchEffect(() => {
  if (model.step < 0 || model.step >= steps.length) {
    emit('closeDialog', hasValidatorErrors.value)
  }
})

function blockAppPointerEvents() {
  const app = document.querySelector('.v-application')
  const dialog = document.querySelector('.v-dialog__content.v-dialog__content--active')
  if (app && dialog) {
    app.classList.add('print-or-save-invoice-dialog')
    dialog.classList.add('print-or-save-invoice-dialog')
  }
}

function unblockAppPointerEvents() {
  const app = document.querySelector('.v-application')
  app!.classList.remove('print-or-save-invoice-dialog')
}

onBeforeMount(async () => {
  await validate()
  loaded.value = true
})
onMounted(() => blockAppPointerEvents())
onUnmounted(() => unblockAppPointerEvents())

</script>

<style lang="scss" scoped>
.print-or-save-dialog-container {
  display: flex;
  flex-direction: column;
  padding: 20px;

  .wizard-container {
    @include flex($justify-content: space-between);
    padding: 0;
  }

  .actions-footer {
    padding: 0;
    margin-top: 20px;
  }
}

</style>

<style lang="scss">
.v-application.print-or-save-invoice-dialog {
  pointer-events: none;
}

.v-dialog__content.v-dialog__content--active.print-or-save-invoice-dialog {
  background-color: $dialog-background-color;
}
</style>
